import { Outlet } from 'react-router';

export function ShareLayout() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-900 to-slate-800">
      <Outlet />
    </div>
  );
}
